export default __webpack_public_path__ + "resources/icons/d222-6647.png";